import { ZoomMode } from "../../../../types/zoom_mode";
import { useCalendarContext } from "../../context/calendar_context";

const CALENDAR_HEADER_HEIGHT = 80;

type UseCalendarHeaderReturn = {
  monthsHeight: number;
  weeksHeight: number;
  daysHeight: number;
};

export const useCalendarHeader = (): UseCalendarHeaderReturn => {
  const { zoomMode } = useCalendarContext();

  if (zoomMode === ZoomMode.Full) {
    return {
      monthsHeight: CALENDAR_HEADER_HEIGHT / 3,
      weeksHeight: CALENDAR_HEADER_HEIGHT / 3,
      daysHeight: CALENDAR_HEADER_HEIGHT / 3 + 1
    };
  }

  return {
    monthsHeight: CALENDAR_HEADER_HEIGHT / 2,
    weeksHeight: CALENDAR_HEADER_HEIGHT / 2 + 1,
    daysHeight: 0
  };
};
